import { client } from './client'
import { normalizeCreditcardsResponse } from './normalize'

const calculateOrder = async (product, currency, locale) => {
  try {
    let response = await client.post(`/v2/order/calculate/${currency}?locale=${locale}`, product)
    return response.data
  } catch (error) {
    throw error
  }
}

// const checkoutOrderV2 = async (order) => {
//   try {
//     let response = await client.post(`/v2/order/`, order)
//     return response.data
//   } catch (error) {
//     throw error
//   }
// }

const checkoutOrderV4 = async (order) => {
  try {
    let response = await client.post(`/v4/order/`, order)
    return response.data
  } catch (error) {
    throw error
  }
}

const setPaymentData = async (data) => {
  try {
    let response = await client.put(`/v4/order/payment/`, data)
    return response
  } catch (error) {
    throw error
  }
}

const fetchOrder = async (orderId) => {
  try {
    let response = await client.get(`/v1/order/${orderId}`)
    return response.data
  } catch (error) {
    throw error
  }
}

const fetchOrderStatus = async (orderId) => {
  try {
    let response = await client.get(`/v1/recurringdetails/${orderId}/status`)
    return response.data
  } catch (error) {
    throw error
  }
}

const fetchSavedCards = async () => {
  try {
    let response = await client.get('/v4/order/paymentmethods')
    let ourResponse = normalizeCreditcardsResponse(response.data)
    return ourResponse
  } catch (error) {
    throw error
  }
}

const updateSubscription = async (pid) => {
  try {
    let response = await client.post(`/v1/autopurchase/${pid}`, { data: null })
    return response.data
  } catch (error) {
    throw error
  }
}

const deleteSubscription = async (pid) => {
  try {
    let response = await client.delete(`/v1/autopurchase/${pid}`, { data: null })
    return response.data
  } catch (error) {
    throw error
  }
}

const deletePaymentMethod = async (pid) => {
  try {
    let response = await client.delete(`/v1/paymentinfo/${pid}`, { data: null })
    return response.data
  } catch (error) {
    throw error
  }
}

const setPaymentMethodAsPrimary = async (pid) => {
  try {
    let response = await client.put(`/v1/paymentinfo/${pid}`, { data: null })
    return response
  } catch (error) {
    throw error
  }
}

const postRecurringPayment = async (data) => {
  try {
    let response = await client.post('/v1/recurringdetails', data)
    return response.data
  } catch (error) {
    throw error
  }
}

const fetchRecurringPayment = async (id) => {
  try {
    let response = await client.get('/v1/recurringdetails/' + id)
    return response.data
  } catch (error) {
    throw error
  }
}

const fetchAutoTopUps = async () => {
  try {
    let response = await client.get('/v1/autopurchase/')
    return response.data
  } catch (error) {
    throw error
  }
}

const setAutoTopUp = async (productId) => {
  try {
    let response = await client.post(`/v1/autopurchase/${productId}`, { data: null })
    return response.data
  } catch (error) {
    throw error
  }
}

const removeAutoTopUp = async (productId) => {
  try {
    let response = await client.delete(`/v1/autopurchase/${productId}`, { data: null })
    return response.data
  } catch (error) {
    throw error
  }
}

const fetchReceipt = async (orderId) => {
  try {
    let response = await client.get(`/v1/order/${orderId}`)
    return response.data
  } catch (error) {
    throw error
  }
}

const fetchPaymentConfiguration = async (providerId) => {
  try {
    let response = await client.get(`/v1/order/paymentconfiguration?providerId=${providerId}`)
    return response.data
  } catch (error) {
    throw error
  }
}

const getPaymentMethodsV4 = async () => {
  try {
    let response = await client.get('/v4/order/paymentmethods')
    return response.data
  } catch (error) {
    throw error
  }
}

const testPaypal = async (model) => {
  try {
    let response = await client.post('/v2/order/en-US', model)
    return response.data
  } catch (error) {
    throw error
  }
}

export {
  calculateOrder,
  // checkoutOrderV2,
  checkoutOrderV4,
  setPaymentData,
  fetchOrder,
  fetchSavedCards,
  updateSubscription,
  deleteSubscription,
  deletePaymentMethod,
  setPaymentMethodAsPrimary,
  postRecurringPayment,
  fetchRecurringPayment,
  fetchReceipt,
  fetchAutoTopUps,
  setAutoTopUp,
  removeAutoTopUp,
  fetchPaymentConfiguration,
  getPaymentMethodsV4,
  testPaypal,
  fetchOrderStatus
}



// WEBPACK FOOTER //
// ./src/api/order/index.js